import rawLevels from "../levels/*.lvl";
import {TilesTypes} from "./Tiles";

const convertOldToNewFormat = (level: string) => {
  const result = [];
  for (let i = 0; i < 15; i++) {
    for (let j = 0; j < 20; j++) {
      let c = level.charAt(j * 15 + i);
      switch (c) {
        case 'G': result.push(TilesTypes.GREEN_ALIEN); break;
        case 'Y': result.push(TilesTypes.YELLOW_ALIEN); break;
        case 'R': result.push(TilesTypes.RED_ALIEN); break;
        default: result.push(parseInt(c))
      }
    }
  }
  return result
}
export const levels = Object.keys(rawLevels).map(key => ({
  name: key,
  tiles: convertOldToNewFormat(rawLevels[key]),
  rows: 15,
  columns: 20,
  completed: !!window.localStorage.getItem(key)
})).sort((a, b) => a.name.localeCompare(b.name))

console.log(levels)